<template>
  <div class="app-container home" v-loading="loading">
    <el-divider/>
    <div class="wcContainer">
      <div v-for="(item ,index) in weiChatCon" :key="index" class="wcItem">
        <div style="height:150px;width: 100%;">
          <img :src=" item.thumb_url" alt="image" @click="clickWeiChatLink(item.url)"
               :title="'点击了解更多：'+item.title" style="width: 100%;height: 100%; object-fit: contain;cursor: pointer;">
        </div>
        <p class="wcTitle">{{ item.title }}</p>
      </div>
    </div>

  </div>
</template>
<script>
import {weiChatCon} from "@/api/dilivery/vx";

export default {
  name: "Index",
  data() {
    return {
      // 版本号
      version: "1.0.0",
      weiChatCon: [],
      loading: true,
    };
  },
  created() {
    this.getWeiChatHref()
    // this.getVersion()
  },
  methods: {
    goTarget(href) {
      window.open(href, "_blank");
    },
    getWeiChatHref() {
      weiChatCon().then(res => {
        if(res.code===200){
          this.weiChatCon = res.data
          this.loading = false
        }

      })
    },
    clickWeiChatLink(url) {
      window.open(url)
    },
  }
};
</script>

<style scoped>
.wcContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  margin: auto;
  gap:60px
}

.wcItem {
  width: 30%;
  min-width: 350px;
  margin: 0 auto;
  //margin-top: 60px;

}
.wcItem>img{
  text-align: center;
  width: 100%;
  height: 100%;
}

P {
  text-align: center;
  width: 100%;
  font-size: 15px;
}
</style>

